import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle, TextareaAutosize,
    TextField
} from "@material-ui/core";

import DescriptionIcon from '@mui/icons-material/Description';


 import React, { useState} from "react";
import axios from "axios";
import { api } from "./api/client";
import IconButton from "@mui/material/IconButton";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import {Grid3x3} from "@mui/icons-material";
import Grid from "@mui/material/Grid";
let timer=0;
let file_name;
export default function ModalBoxSevkiyatNotu(props) {
    const [open, setOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [openPop, setOpenPop] = useState(false);
    const [teklif_no, setTeklif_no] = useState(null);
    const [selectedFile,setSelectedFile]= useState();
    const [fileName, setFileName] = useState("");
    const [state, setState] = useState({
        id:props.id,
        sevk_notlari:props.sevk_notu

    });
    const  handlePopoverOpen = (event) => {
        setState({sevk_notlari:props.sevk_notu, id: props.id});

        if (state.sevk_notlari) {
            setAnchorEl(event.currentTarget);
            timer = setTimeout(()=>{setOpenPop(true)},1000)
            console.log('mouse girdi')
        }
    };

    // On file select (from the pop up)
    const onFileChange = event => {

        // Update the state
        setSelectedFile(event.target.files[0]);
        console.log(event.target.files[0])

    };
    // On file upload (click the upload button)
    const onFileUpload = () => {

        // Create an object of formData
        const formData = new FormData();

        // Update the formData object
        formData.append(
            "myFile",
            selectedFile,
            selectedFile.name
        );
        formData.append(
            "teklif_no",
             teklif_no
        );
        // Details of the uploaded file
        console.log(selectedFile);

        // Request made to the backend api
        // Send formData object
        api.post(`/teklifler/${encodeURIComponent(state.id || props.id)}/sevk-dosya`, formData);
    };



    const  handlePopoverClose = (event) => {
        setAnchorEl(null);
        setOpenPop(false);
        setTeklif_no(null)
    };
    const handleChange = name => e => {
        setState({
            ...state,
            [name]: e.target.value
        });
        console.log('state change',state);
    };

    const handleClickOpen = () => {


        setOpen(true);
        setTeklif_no(props.teklif_no)
        setState({sevk_notlari:props.sevk_notu, id: props.id});

     };

    const handleClose = () => {
        setOpen(false);
    };
    function onMouseLeave() {
        clearTimeout(timer);
        console.log('mouse çıktı')
    }

    return (
        <div>
            <IconButton variant="outlined"  style={{color: state.sevk_notlari ? "green": "red"}} size={"small"} color="success" onClick={handleClickOpen }
                        aria-owns={open ? 'mouse-over-popover' : undefined}
                        aria-haspopup="true"
                        onMouseEnter={handlePopoverOpen}
                        id={props.teklifNo}
                        onMouseLeave={onMouseLeave}
            >
            <DescriptionIcon />
            </IconButton>



            <Popover
                id="mouse-over-popover"
                sx={{
                    pointerEvents: 'auto',
                }}
                open={openPop}
                anchorEl={anchorEl}
                onClose={handlePopoverClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right"
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left"
                }}
            >
            <div style={{width:400}}>
                    {state.sevk_notlari || ""}
            </div>
            </Popover>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
                maxWidth="md"
            >
                <DialogTitle id="form-dialog-title">Makine Sevkiyatı İçin Not ve Dosya Ekle</DialogTitle>
                <DialogContent>



                    <input type="file" onChange={onFileChange}  accept=".pdf,.jpg,.png"/>

                    <p></p>
                    <Grid container>

                        <Grid>
                            <DialogContentText>
                                Sevk Notları Giriniz
                            </DialogContentText>
                            <TextareaAutosize
                            margin="dense"
                            id="sevk_notlari"
                            label="Sevkiyat Notları"
                            type="tel"
                            value={state.sevk_notlari || ""}
                            onChange={handleChange("sevk_notlari")}
                            fullWidth
                            multiline
                            minRows="8"
                            style={{ width: 400 }}
                        /></Grid>

                    </Grid>

                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        İptal
                    </Button>
                    <Button

                        onClick={

                            async () => {
                                if(selectedFile) {
                                    // Create an object of formData
                                    const formData = new FormData();

                                    // Update the formData object
                                    formData.append(
                                        "myFile",
                                        selectedFile,
                                        selectedFile.name
                                    );
                                    formData.append(
                                        "teklif_no",
                                        teklif_no
                                    );
                                    // Details of the uploaded file
                                    //console.log(selectedFile);

                                    // Request made to the backend api
                                    // Send formData object
                                    api.post(`/teklifler/${encodeURIComponent(state.id || props.id)}/sevk-dosya`, formData).then((response) => {
                                        // Success 🎉
                                        file_name = response.data;
                                    });

                                    setTimeout(async ()=>{  await api.post('/teklifler/' + state.id + '/sevk-notu?id=' + state.id, {
                                        'sevkiyat_notlari': state.sevk_notlari,
                                        'irsaliye': file_name
                                    })
                                        .then((response) => {
                                            // Success 🎉
                                            console.log(response);
                                            handleClose();
                                            props.sevkEdilmis(true);
                                        })
                                        .catch((error) => {
                                            // Error 😨
                                            if (error.response) {
                                                /*
                                                 * The request was made and the server responded with a
                                                 * status code that falls out of the range of 2xx
                                                 */
                                       /* console.log(error.response.data);
                                        console.log(error.response.status);
                                        console.log(error.response.headers);
                                    } else if (error.request) {
                                        /*
                                         * The request was made but no response was received, `error.request`
                                         * is an instance of XMLHttpRequest in the browser and an instance
                                         * of http.ClientRequest in Node.js
                                         */
                                       console.log(error.request);
                                    } else {
                                        // Something happened in setting up the request and triggered an Error
                                        console.log('Error', error.message);
                                    }
                                    console.log(error.config);
                                });},1000)
                            setState({open:false});
                        }
                        else  {
                             await api.post('/teklifler/' + state.id + '/sevk-notu?id=' + state.id, {
                                'sevkiyat_notlari': state.sevk_notlari,

                            })
                                .then((response) => {
                                    // Success 🎉
                                    console.log(response);
                                    handleClose();
                                    props.sevkEdilmis(true);
                                })
                                .catch((error) => {
                                    // Error 😨
                                    if (error.response) {
                                        /*
                                         * The request was made and the server responded with a
                                         * status code that falls out of the range of 2xx
                                         */
                                        /* console.log(error.response.data);
                                         console.log(error.response.status);
                                         console.log(error.response.headers);
                                     } else if (error.request) {
                                         /*
                                          * The request was made but no response was received, `error.request`
                                          * is an instance of XMLHttpRequest in the browser and an instance
                                          * of http.ClientRequest in Node.js
                                          */
                                        console.log(error.request);
                                    } else {
                                        // Something happened in setting up the request and triggered an Error
                                        console.log('Error', error.message);
                                    }
                                    console.log(error.config);
                                });}
                        }  }
                        color="primary"
                    >
                     Notu   Kaydet
                    </Button>
                </DialogActions>
            </Dialog></div>
    )
}

